module.exports = __webpack_public_path__ + "img/密码-2.7fa91452.png";